import { ApiPath } from "enums";
import { Get, Post, Put } from "utils";

export const getPurchaseOrderListApi = async (query) => {
  const res = await Get(`${ApiPath.PurchaseOrder}`, query);
  return res.data;
};

export const createPurchaseOrderApi = async (query) => {
  const res = await Post(`${ApiPath.PurchaseOrder}`, query);
  return res.data;
};

export const getPurchaseOrderByIdApi = async (query) => {
  const res = await Get(`${ApiPath.PurchaseOrder}/${query?.id}`, query);
  return res.data;
};

export const updatePurchaseOrderByIdApi = async (query) => {
  const res = await Put(`${ApiPath.PurchaseOrder}/${query?.id}`, query);
  return res.data;
};
